import { render } from "./ChildReportDetail.vue?vue&type=template&id=3d10c028&scoped=true&ts=true"
import script from "./ChildReportDetail.vue?vue&type=script&lang=ts"
export * from "./ChildReportDetail.vue?vue&type=script&lang=ts"

import "./ChildReportDetail.vue?vue&type=style&index=0&id=3d10c028&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d10c028"]])

export default __exports__